(function() {
  var btn = document.getElementById('tw-back-to-top');
  if (btn) {
    function toggle() { btn.classList.toggle('tw-opacity-100', window.scrollY > 400); btn.classList.toggle('tw-pointer-events-auto', window.scrollY > 400); }
    window.addEventListener('scroll', toggle);
    toggle();
    btn.addEventListener('click', function(e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  document.querySelectorAll('.tw-footer__heading').forEach(function(heading) {
    heading.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.innerWidth < 768) {
        var block = this.closest('.tw-footer__block');
        var isActive = block.classList.contains('is-active');
        
        document.querySelectorAll('.tw-footer__block').forEach(function(b) {
          if (b !== block) b.classList.remove('is-active');
        });

        if (!isActive) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      }
    });
  });

  document.querySelectorAll('#FooterCountryForm select[data-submit], #FooterLanguageForm select[data-submit]').forEach(function(el) {
    el.addEventListener('change', function() { this.form.submit(); });
  });
})();